@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.pill-bank {
  min-height: 48px;
  border: 1px solid @pill-blank--border-color;
  border-radius: 4px;
  padding: 5px;
  margin-top: 5px;
}

.pill {
  margin: 5px;
}
